module.exports = __webpack_public_path__ + "img/graph-purple.2f098232.webp";